var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9251101,10 L6.969163,10 L6.969163,12 L16.9251101,12 L16.9251101,10 Z M18.9162996,3 L17.9207048,3 L17.9207048,1 L15.9295154,1 L15.9295154,3 L7.96475771,3 L7.96475771,1 L5.97356828,1 L5.97356828,3 L4.97797357,3 C3.87286344,3 2.98678414,3.9 2.98678414,5 L2.98678414,19 C2.98678414,20.1 3.87286344,21 4.97797357,21 L18.9162996,21 C20.0114537,21 20.907489,20.1 20.907489,19 L20.907489,5 C20.907489,3.9 20.0114537,3 18.9162996,3 Z M18.9162996,19 L4.97797357,19 L4.97797357,8 L18.9162996,8 L18.9162996,19 Z M13.938326,14 L6.969163,14 L6.969163,16 L13.938326,16 L13.938326,14 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFE0-Home-&-Menus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_Home_Hamburger_Not-LoggedIN",
    transform: "translate(-18.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "34.-Icons/filled/notification/event_note_24px-Copy",
    transform: "translate(15.929515, 107.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/notification/event_note_24px",
    fillOpacity: 0.87,
    fill: "currentColor",
    xlinkHref: "#path-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default ForwardRef;